import styled from 'styled-components';

export const SubscriptionTrustRow = styled.div`
    margin-top: 16px;
    margin-bottom: 12px;
    padding: 14px 16px;
    background: #F4F5F7;
    border-radius: 12px;

    display: flex;
    align-items: flex-start;
    gap: 10px;

    font-size: 13px;
    line-height: 1.4;
    color: #6b7280;
`;

export const TrustIcon = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    margin-top: 2px;
    svg { width: 14px; height: 14px; }
`;

export const TrustText = styled.span`
    display: inline-flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;

    .phrase {
        white-space: nowrap;    
    }

    .sep {
        opacity: 0.6;
        margin: 0 6px;
        user-select: none;
    }
`;
